// authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: false,
    user: null,
    tenantId: null,
  },
  reducers: {
    setUser: (state, action) => {
      console.log("🚀 ~ file: authSlice.ts:13 ~ action:", action)
      state.isAuthenticated = true;
      state.user = action.payload.username;
      console.log("🚀 ~ file: authSlice.ts:18 ~ action.payload.attribut:", action.payload.attributes['custom:tenantId'])
      console.log("🚀 ~ file: authSlice.ts:16 ~ action.payload.username:", action.payload.username)
      state.tenantId = action.payload.attributes["custom:tenantId"]
    },
    clearUser: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    },
  },
});

export const { setUser, clearUser } = authSlice.actions;
export default authSlice.reducer;
